import React from 'react'

const ErrorFetching = () => {
    return (
        <section className="section is-medium">
            <h1 className="title">🤯 Error fetching data</h1>
            <h2 className="subtitle">
                A simple container to divide your page into <strong>sections</strong>, like the one you're currently reading.
            </h2>
        </section>
    )
}

export default ErrorFetching
